import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Textfield from '@atlaskit/textfield';

import { RootState } from '../../store/store';
import { ErrorMessage, FormLabel } from '../../styled';

const Name: React.FC = () => {
    const { control } = useFormContext();
    const { canEdit } = useSelector((state: RootState) => state.incidentBanners);

    return (
        <Controller
            name='name'
            control={control}
            render={({ field, fieldState }) => (
                <div>
                    <FormLabel>Internal name</FormLabel>
                    <Textfield
                        onChange={field.onChange}
                        value={field.value}
                        isDisabled={!canEdit}
                    />
                    {fieldState.error && <ErrorMessage>{fieldState.error.message}</ErrorMessage>}
                </div>
            )}
        />
    );
};

export default Name;
